import React from "react";

import styles from "./footer.module.css";

const Footer = () => {
  return (
    <div className={styles.Footer}>
      <h3>simple weather app</h3>
    </div>
  );
};

export default Footer;
